/** The "show no longer valid" switch, for the views under `components/` (PRD-0075 R-C4). */
import { useFactVisibilityStore } from '@/stores/fact-visibility-store'

export function useShowNoLongerValid(): [boolean, (show: boolean) => void] {
  const show = useFactVisibilityStore(s => s.showNoLongerValid)
  const setShow = useFactVisibilityStore(s => s.setShowNoLongerValid)
  return [show, setShow]
}
